module.exports = __webpack_public_path__ + "static/media/inf_100og101.b5d54c2c.mp3";